import { Product } from "@ludens-reklame/rubics-v3-sdk/product/types";
import { ProductProps } from "../../types/product.js";
import {
  Constrainer,
  HorizontalSpacer,
} from "../../internal-components/Layout.js";
import { Wrapper } from "../FilterableProducts/styles.js";
import { RichText } from "../../internal-components/RichText.js";
import { ProductGrid } from "../../internal-components/product/ProductGrid.js";
import { ProductCard } from "../../internal-components/product/ProductCard.js";
import { createEditableProps } from "@ludens-reklame/rubics-v3-react/util/fns";

interface Props {
  text?: string;
  products?: { product?: Product<ProductProps> }[];
}

export const SelectedProducts: React.FC<Props> = ({ text, products = [] }) => {
  return (
    <Wrapper $xl>
      <HorizontalSpacer>
        <Constrainer>
          {text && (
            <RichText
              $centered
              dangerouslySetInnerHTML={{ __html: text }}
              {...createEditableProps("html", "text")}
            />
          )}
          <ProductGrid $maxColumns={4}>
            {products.map((p) => {
              if (!p.product) {
                return null;
              }

              return <ProductCard key={p.product._id} product={p.product} />;
            })}
          </ProductGrid>
        </Constrainer>
      </HorizontalSpacer>
    </Wrapper>
  );
};
